<template>
    <main>
        <slot></slot>
    </main>
</template>

<script>
</script>

<style lang="scss">
@use "./index.scss";
</style>
